import DiceRollerGame from './DiceRollerGame';
import { diceRollerDefinition } from './diceRollerDefinition';

const diceRollerIcon = {
  id: 'dice-roller',
  src: `${process.env.PUBLIC_URL}/game-icons/dice-roller.png`,
};

export const diceRollerGameModule = {
  id: diceRollerDefinition.id,
  name: diceRollerDefinition.name,
  summary: diceRollerDefinition.summary,
  component: DiceRollerGame,
  definition: diceRollerDefinition,
  accent: 'green',
  icon: diceRollerIcon,
  releaseState: 'released',
  controls: {
    movement: 'none',
    actions: ['roll', 'flip'],
    notes: 'Choose a die or coin, then press Roll or use Space and Enter.',
  },
  playableIcons: [],
};
